/* eslint-disable no-lone-blocks */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, {
    useState, useCallback, useEffect, useRef,
} from 'react';
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../../redux/helper/CreateQuery';
import { distributorService } from '../../../service/distributor.service';

function OutstandingFilterModal({
    outstandingfilterModal, setoutstandingFilterModal, selected, setselected, Filter, setFilter, handleFilter, setfilterValue, filterValue, handleOutstandingInvoiceReport, outstandingInvoiceList, setOutstandingInvoiceList, SetSuccessMessage,

}) {
    const dateRef = useRef();
    const dateRef1 = useRef();
    const [selectedType, setselectedType] = useState('gst_invoice_date');
    const [distributorSearchResult, setdistributorSearchResult] = useState([]);
    const [searchValue, serSearchValue] = useState('');
    const [searchDropdown, setSearchDropdown] = useState(false);

    const toggleState = {
        gst_start_date: false,
        gst_end_date: false,
        ar_start_date: false,
        ar_end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const onChangeSearch = (value) => {
        serSearchValue(value);
        distributorService.DistributorList(1, value, '', '').then((val) => {
            if (val.data.success_status) {
                setdistributorSearchResult(val.data.data);
            }
        });
    };

    useEffect(() => {
        distributorService.DistributorList(1, '', '', '').then((val) => {
            if (val.data.success_status) {
                setdistributorSearchResult(val.data.data);
            }
        });
    }, []);

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateFilterQuery = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'customer_code':
                if (Filter[key].length > 0) {
                    final += `&customer_code=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
            return final;
        });
        if (selected.gst_start_date !== '' && selected.gst_end_date !== '') {
            final += `&TRX_DATE=${moment(selected.gst_start_date).format('YYYY/MM/DD')}-${moment(selected.gst_end_date).format('YYYY/MM/DD')}`;
        }
        if (selected.ar_start_date !== '' && selected.ar_end_date !== '') {
            final += `&AR_DATE=${moment(selected.ar_start_date).format('YYYY/MM/DD')}-${moment(selected.ar_end_date).format('YYYY/MM/DD')}`;
        }

        if (val === undefined) {
            handleFilter(final);
        }
        setoutstandingFilterModal(false);
        SetSuccessMessage('Filters applied Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    const handleDateGST = (val, key) => {
        const state = key === 'gst_start_date' ? 'gst_end_date' : 'gst_start_date';
        if (key === 'gst_start_date') {
            setselected((prevState) => ({
                ...prevState,
                gst_end_date: '',
            }));
        }
        settoggle({
            gst_start_date: false,
            gst_end_date: false,
            ar_start_date: toggle.ar_start_date,
            ar_end_date: toggle.ar_end_date,
        });
        if (key === 'gst_end_date') {
            settoggle({
                gst_start_date: false,
                gst_end_date: false,
                ar_start_date: toggle.ar_start_date,
                ar_end_date: toggle.ar_end_date,
            });
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
    };

    const handleDateAR = (val, key) => {
        const state = key === 'ar_start_date' ? 'ar_end_date' : 'ar_start_date';
        if (key === 'ar_start_date') {
            setselected((prevState) => ({
                ...prevState,
                ar_end_date: '',
            }));
        }
        settoggle({
            gst_start_date: toggle.gst_start_date,
            gst_end_date: toggle.gst_start_date,
            ar_start_date: false,
            ar_end_date: false,
        });
        if (key === 'ar_end_date') {
            settoggle({
                gst_start_date: toggle.gst_start_date,
                gst_end_date: toggle.gst_start_date,
                ar_start_date: false,
                ar_end_date: false,
            });
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
    };

    const handleClear = () => {
        setFilter({
            customer_code: [],
        });
        setselected((prevState) => ({
            ...prevState,
            gst_start_date: '',
            gst_end_date: '',
            ar_start_date: '',
            ar_end_date: '',
        }));
        setfilterValue('');
        handleOutstandingInvoiceReport();
        setoutstandingFilterModal(false);
        SetSuccessMessage('Filter(s) cleared!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    gst_start_date: false,
                    gst_end_date: false,
                }));
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef1 && !dateRef1.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    ar_start_date: false,
                    ar_end_date: false,
                }));
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef1]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${outstandingfilterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[520px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setoutstandingFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={() => setselectedType('gst_invoice_date')}>
                                    <a
                                        href="#pills-price"
                                        className={`nav-link block text-base ${selectedType === 'gst_invoice_date' ? 'active' : ''} font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="Gst-invoice-date"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-price"
                                        role="tab"
                                        aria-controls="pills-price"
                                        aria-selected="true"
                                    >
                                        GST Invoice Date
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full my-4" role="presentation" onClick={() => setselectedType('ar_date')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block text-base ${selectedType === 'ar_date' ? 'active' : ''} font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="Ar-date"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-profileVertical"
                                        role="tab"
                                        aria-controls="pills-profileVertical"
                                        aria-selected="false"
                                    >
                                        AR Date
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('customer_code')}>
                                    <a
                                        href="#pillcategorie"
                                        className={`nav-link block ${selectedType === 'customer_code' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-type"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pillcategorie"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Customer Code
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div ref={dateRef} className={`tab-pane ${selectedType === 'gst_invoice_date' ? 'show active' : ''} fade px-3`} id="pills-price" role="tabpanel" aria-labelledby="Gst-invoice-date">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('gst_start_date')}
                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('gst_start_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.gst_start_date === '' ? '' : moment(selected.gst_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.gst_start_date && (
                                                <Calendar
                                                    value={moment(selected.gst_start_date).format('YYYY/MM/DD').gst_start_date}
                                                    onChange={(val) => handleDateGST(val, 'gst_start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('gst_end_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('gst_end_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.gst_end_date === '' ? '' : moment(selected.gst_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.gst_end_date && (
                                                <Calendar
                                                    value={(selected.gst_end_date)}
                                                    onChange={(val) => handleDateGST(val, 'gst_end_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div ref={dateRef1} className={`tab-pane ${selectedType === 'ar_date' ? 'show active' : ''} fade  px-3`} id="pills-profileVertical" role="tabpanel" aria-labelledby="Ar-date">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('ar_start_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('ar_start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.ar_start_date === '' ? '' : moment(selected.ar_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.ar_start_date && (
                                                <Calendar
                                                    value={moment(selected.ar_start_date).format('YYYY/MM/DD').ar_start_date}
                                                    onChange={(val) => handleDateAR(val, 'ar_start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('ar_end_date')}
                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('ar_end_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.ar_end_date === '' ? '' : moment(selected.ar_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.ar_end_date && <Calendar value={selected.ar_end_date} onChange={(val) => handleDateAR(val, 'ar_end_date')} minDate={moment(selected.ar_end_date).toDate()} placeholder="Date to" />}
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'customer_code' ? 'show active' : ''} fade w-full px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-type">
                                    <div className="dropdown relative">
                                        <input
                                            type="text"
                                            id="distributors"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="dropdown-to h-[30px] w-[238px] outline-0 border rounded-t-[4px] border-[#D8D8D8] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                            autoComplete="off"
                                            value={searchValue}
                                            placeholder="Search Customer Code"
                                            onClick={() => setSearchDropdown(!searchDropdown)}
                                            onChange={(e) => {
                                                { onChangeSearch((e.target.value).trim()); }
                                            }}
                                        />
                                        {distributorSearchResult && searchDropdown && (
                                            <ul className="dropdown-menu  absolute h-[145px] w-[245px] overflow-y-auto overflow-x-hidden bg-[#FFFFFF]  shadow-s2 z-[9999] right-[32px]" aria-labelledby="HIP14">
                                                {distributorSearchResult.length > 0 && distributorSearchResult.map((ele) => (
                                                    <li className="py-[8px] pl-[10px]">
                                                        <div className="flex items-center ">
                                                            <Checkbox
                                                                icon={
                                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.customer_code?.includes(ele?.ACCOUNT_NUMBER) ? '#555259' : ''}` }} />
                                                                }
                                                                name="my-input"
                                                                className="cursor-pointer"
                                                                checked={Filter.customer_code?.includes(ele?.ACCOUNT_NUMBER)}
                                                                onChange={() => HandleFilter('customer_code', ele?.ACCOUNT_NUMBER)}
                                                                borderColor={`${Filter.customer_code?.includes(ele?.ACCOUNT_NUMBER) ? '#B8C5DC' : '#555259'}`}
                                                                style={{ cursor: 'pointer' }}
                                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                            />
                                                            <label htmlFor="mn50" className="consumbales pl-3 text-sm46 font-normal text-[#090406] text-left cursor-pointer">{ele.ACCOUNT_NUMBER}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-5">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OutstandingFilterModal;
